// TODO: vertical testing needs to be centralized.
const REGEX = /mach|better|think|globalcitizen|leftfield/i;

export default ({ source }) => source && source.name && REGEX.test(source.name);
